
export class Template {
	public templateID: string;
	public templateName: string;
	public templateJSON: string;
	public templateHtml: string; // exported HTML, sent for server-side substitution-field validation (not persisted)

	constructor(o?: any) {
		Object.assign(this, o);
	}
}